import { Component, OnInit, SimpleChanges, OnChanges, ChangeDetectorRef, AfterViewInit, OnDestroy, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AppConfig } from 'src/app/api/helper/app.config';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { AuftragAnlegenRequest, Auftragstyp, Vertrag } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { SystemService } from 'src/app/api/system.service';
import { VertragPositionenComponent } from '../vertrag-positionen/vertrag-positionen.component';

const log = new Logger("VertragDetailsComponent");

@Component({
    selector: 'app-vertrag-details',
    templateUrl: './vertrag-details.component.html',
    styleUrls: ['./vertrag-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VertragDetailsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    static instance: VertragDetailsComponent;

    @Input() vertrag: Vertrag;
    @Input() auftragstyp: Auftragstyp;

    isVisible = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private systemService: SystemService,
        private stammdatenService: StammdatenService,
        private auftragService: AuftragService,
        private remoteService: RemoteService,
        private modalController: ModalController,) {

        VertragDetailsComponent.instance = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        log?.debug('ngOnChanges');
    }

    ngOnDestroy(): void {
        log?.debug('ngOnDestroy');
        this.isVisible = false;
        MyApp.loading(false);
    }

    async ngOnInit() {
        log?.debug('ngOnInit');

        this.isVisible = true;
    }

    async ngAfterViewInit() {
        log?.debug('ngAfterViewInit');
    }

    onClose() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    async onVorauswahlPos() {
        // log?.debug('onClose');
        // this.modalController.dismiss(null);
        
        const modal = await this.modalController.create({
            component: VertragPositionenComponent,
            componentProps: {
                vertrag: this.vertrag,
                auftragstyp: this.auftragstyp
            }
        });
    
        await modal.present();
    
        // this.log?.debug('modal', modal);
    
        const result = await modal.onDidDismiss();
    }

    async onNeuerAuftrag() {
        log?.debug('onNeuerAuftrag');

        MyApp.loading(true);

        const request: AuftragAnlegenRequest = {
            Auftragstyp: this.auftragstyp,
            Vertragsnummer: this.vertrag.Vertragsnummer,
            Art: 'Vertrag',
            FahrzeugKennzeichen: MyApp.current.getFahrzeugKennzeichen(),
            FahrzeugKey: MyApp.current.getFahrzeugKey(),
            GeraeteNummer: AppConfig.current.geraeteNummer,
            TourKey: '',
            UnterMandant: AppConfig.current.UnterMandant
        };

        const fahrer = MyApp.current.fahrer.getValue();

        if (fahrer) {
            request.Personalnummer = fahrer.personalnummer;
            request.PersonalKey = fahrer.Key;
            request.PersonalName = fahrer.vorname + ' ' + fahrer.nachname;
        }

        const aktuelleTour = MyApp.current.aktuelleTour.getValue();

        if (aktuelleTour) {
            request.TourKey = aktuelleTour.TourKey;
        }

        const result = await this.remoteService.auftragAnlegen(request);

        if (!result) {
            UiHelper.showFehlerKommunikation();
            return;
        }

        if (result.ErrorMessage) {
            UiHelper.showErrorOhneSentry(result.ErrorMessage);
            return;
        }

        if (result.Success && result.Auftrag) {
            await this.auftragService.speichereAuftrag(result.Auftrag);

            this.modalController.dismiss({
                type: 'neuer-auftrag',
                auftrag: result.Auftrag
            });
        };
    }
}
